import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Search from "../../../components/form/Search";
// import Button from "../../components/form/Button";
import Table from "../../../components/elements/table/Table";
import { setTitle } from "../../../helpers/MetaTag";
import { handleFilterChange, removeDuplicateFromArray } from "../../../helpers";
// import DeleteModal from "../../components/common/DeleteModal";

import useFetch from "../../../hooks/useFetch";
import { useDebounce } from "../../../hooks/useDebounce";
import LimitSelect from "../../../components/elements/LimitSelect";
// import useMutation from "../../hooks/useMutation";

import dayjs from "dayjs";
// import ManageFinanceModal from "../../components/sections/admin/Finance/modals/ManageFinanceModal";
import { transactionList } from "../../../services/transactionService";
import DatePicker from "../../../components/form/DatePicker";
import MultiselectDropdown from "../../../components/form/MultiselectDropdown";
import { userList } from "../../../services/userService";
import SearchWithDropdown from "../../../components/form/SearchWithDropdown";
import Badge from "../../../components/elements/Badge";

const Transaction = ({ userId }) => {
  // console.log(userId);
  setTitle("MemoryDoodle Admin | Transaction");
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [userFilters, setUserFilters] = useState({
    limit: 100,
    page: 1,
  });
  const [userSearch, setUserSearch] = useState("");

  const debouncedUserSearch = useDebounce(userSearch, 300);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const {
    data: users,
    error: userError,
    isLoading: userLoading,
    updateData: updateUsers,
    isFetching: isFetchingUsers,
    refetch: refetchUsers,
  } = useFetch({
    dependencies: ["users", userFilters, debouncedUserSearch],
    fetchFunction: async () => {
      const res = await userList({
        ...userFilters,
        // roleCode: "USER",
        ...(debouncedUserSearch && { keyword: debouncedUserSearch }),
      });

      if (res?.docs?.status === 200) {
        const newData = res?.docs?.data || [];
        return {
          ...res?.docs,
          data:
            userFilters.page > 1
              ? removeDuplicateFromArray(
                  [...(users?.data || []), ...newData],
                  "_id"
                )
              : newData, // if page = 1, reset data
        };
      } else {
        return {
          data: [],
          metadata: {
            totalDocs: 0,
            totalPages: 0,
            page: 1,
          },
        };
      }
    },
  });
  useEffect(() => {
    if (userId) {
      setFilters((prev) => ({
        ...prev,
        userId: [userId],
      }));
    }
  }, [userId]);
  const shouldFetch = userId && filters?.userId?.length > 0;
  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    enabled: shouldFetch,
    dependencies: ["transaction", filters, search, dateRange],
    fetchFunction: async () => {
      const {
        type = [],
        paymentStatus = [],
        userId = [],
        ...restFilters
      } = filters || {};
      const res = await transactionList({
        ...restFilters,
        ...Object.fromEntries(type.map((val, i) => [`type[${i}]`, val])),
        ...Object.fromEntries(
          paymentStatus.map((val, i) => [`paymentStatus[${i}]`, val])
        ),
        // categoryType: "fiance",
        ...Object.fromEntries(userId.map((val, i) => [`userId[${i}]`, val])),
        // ...(userId && { userId }),
        ...(dateRange?.startDate && {
          startDate: dayjs(dateRange.startDate).toISOString(),
        }),
        ...(dateRange?.endDate && {
          endDate: dayjs(dateRange.endDate).toISOString(),
        }),
        ...(search && { keyword: search }),
      });
      return res?.docs;
    },
  });

  //   Transaction status change handler =================>
  //   const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
  //     useMutation({
  //       mutationFn: async ({ id, status }) => {
  //         const res = await transactionStatusChange({
  //           ids: id,
  //           status,
  //         });
  //         return { res, payload: { id, status } };
  //       },
  //       onSuccess: ({ res, payload }) => {
  //         if (res?.status !== 200) {
  //           updateData((pre) => {
  //             pre.data = (pre?.data || []).map((elm) =>
  //               elm?._id === payload?.id
  //                 ? { ...elm, status: payload?.status === 1 ? 2 : 1 }
  //                 : elm
  //             );
  //             return { ...pre };
  //           });
  //         }
  //       },
  //       onError: (error) => {
  //         console.log(error);
  //       },
  //     });

  const tableHeadData = [
    // {
    //   _id: 3,
    //   name: "Plan Name",
    //   align: "left",
    // },
    {
      _id: 4,
      name: "Plan Name",
      align: "left",
    },
    {
      _id: 2,
      name: "User Name",
      align: "left",
      isFilter: !userId, // 👈 hide the filter if a specific userId is already passed
      isFilterSearch: !userId, // 👈 optional: also disable search in filter
      filterSearch: (e) => setUserSearch(e),
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((pre) => ({
            ...pre,
            userId: val.map((item) => item.value),
          }));
        } else {
          setFilters((pre) => {
            delete pre.userId;
            return { ...pre };
          });
        }
      },
      filterData: (users?.data || []).map((user) => ({
        value: user._id,
        name: `${user.firstName} ${user.lastName}`,
        type: "checkbox",
      })),
      // onScroll: (e) => loadData(e, users, setUserFilters),
      onScroll: (e) => console.log(e),
    },
    {
      _id: 5,
      name: "Transaction Date",
      align: "left",
    },
    {
      _id: 5,
      name: "Transaction Payable",
      align: "left",
    },
    // {
    //   _id: 4,
    //   name: "Received",
    //   align: "left",
    // },
    // {
    //   _id: 6,
    //   name: "Payment For",
    //   align: "left",
    //   isFilter: true,
    //   isFilterSearch: false,
    //   onFilter: (val) => {
    //     if (val?.length > 0) {
    //       setFilters((pre) => ({
    //         ...pre,
    //         type: val?.map((item) => item?.value),
    //         page: 1,
    //       }));
    //     } else {
    //       setFilters((pre) => {
    //         delete pre?.type;
    //         return { ...pre };
    //       });
    //     }
    //   },
    //   filterData: [
    //     { name: "Subscription", value: "subscription", type: "checkbox" },
    //     { name: "Topup", value: "topup", type: "checkbox" },
    //   ],
    // },
    // {
    //   _id: "paymentStatus",
    //   name: "Transaction Status",
    //   align: "left",
    //   isFilter: true,
    //   isFilterSearch: false,
    //   onFilter: (val) => {
    //     if (val?.length > 0) {
    //       setFilters((pre) => ({
    //         ...pre,
    //         paymentStatus: val?.map((item) => item?.value),
    //         page: 1,
    //       }));
    //     } else {
    //       setFilters((pre) => {
    //         delete pre?.paymentStatus;
    //         return { ...pre };
    //       });
    //     }
    //   },
    //   filterData: [
    //     { name: "Pending", value: "pending", type: "checkbox" },
    //     { name: "Success", value: "success", type: "checkbox" },
    //   ],
    // },
    {
      _id: 7,
      name: "Status",
      align: "left",
    },
    // {
    //   _id: 8,
    //   name: "Action",
    //   align: "left",
    // },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        // {
        //   _id: 3,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: item?.planDetail?.name || "-",
        // },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: <div>{item?.planDetail?.name}</div>,
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            `${item?.userData?.firstName || ""} ${
              item?.userData?.lastName || ""
            }`.trim() || "-",
        },

        // {
        //   _id: 6,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: item?.recived || "-",
        // },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.createdAt
            ? dayjs(item?.createdAt).format("DD MMM, YYYY")
            : "-",
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.totalPayable || "-",
        },
        {
          _id: 7,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="flex gap-2 items-center">
              <Badge
                type={item?.status === "completed" ? "success" : "danger"}
                label={
                  item?.status === "completed" ? "completed" : item?.status
                }
              />
            </div>
          ),
        },
        // {
        //   _id: 9,
        //   type: "action",
        //   align: "left",
        //   cellClass: "w-[5%]",
        //   actionData: [
        //     {
        //       _id: 1,
        //       name: "Edit",
        //       icon: "fa-regular fa-pen-to-square",
        //       onClick: () => {
        //         setModalOpen({ isOpen: true, data: item });
        //       },
        //       standout: false,
        //     },

        //     {
        //       _id: 2,
        //       name: "Delete",
        //       icon: "fa-regular fa-trash-can",
        //       standout: true,
        //       onClick: () => {
        //         setDeleteModal({
        //           isOpen: true,
        //           data: item,
        //         });
        //       },
        //     },
        //   ],
        // },
      ],
    };
  });

  // add or edit Transaction =================>
  //   function donationManageResponse(res) {
  //     if (res?.status === 200 || res?.status === 201) {
  //       if (res?.status === 201) {
  //         if (filters?.page === 1) {
  //           updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
  //           refetch();
  //         } else {
  //           setFilters((pre) => ({ ...pre, page: 1 }));
  //         }
  //       }
  //       if (res?.status === 200) {
  //         updateData((pre) => ({
  //           ...pre,
  //           data: pre?.data?.map((item) =>
  //             item?._id === res?.data?._id ? res?.data : item
  //           ),
  //         }));
  //       }
  //       setModalOpen({ isOpen: false, data: null });
  //     } else {
  //       toast.warning(res?.message);
  //     }
  //   }

  //  Transaction delete handler =================>
  //   const { mutate: deleteHandler, isPending: deletePending } = useMutation({
  //     mutationFn: async (payload) => {
  //       const res = await transactionDelete({
  //         ids: Array.isArray(payload) ? payload : [payload],
  //       });
  //       return { res, payload: Array.isArray(payload) ? payload : [payload] };
  //     },
  //     onSuccess: ({ res, payload }) => {
  //       if (res?.status === 200) {
  //         setDeleteModal({ isOpen: false, data: null });
  //         updateData((pre) => {
  //           pre.data = (pre?.data || [])?.filter(
  //             (item) => !payload?.includes(item?._id)
  //           );
  //           return { ...pre };
  //         });
  //         if (data?.metadata?.totalDocs > filters?.limit) {
  //           refetch();
  //         }
  //       }
  //     },
  //     onError: (error) => {
  //       console.log(error);
  //     },
  //   });
  function loadData(e, obj, setData = () => {}) {
    if (
      Math.ceil(e.target.scrollTop) + 20 >=
        e.target.scrollHeight - e.target.clientHeight &&
      obj?.metadata?.hasNextPage
    ) {
      setData((pre) => ({
        ...pre,
        page: obj?.metadata?.nextPage,
      }));
    }
  }
  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Transactions Management 
        </div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search Here.."}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 0, setFilters);
              }}
            />
          </div>
          {/* <div className="w-72">
           <MultiselectDropdown
              isSearch={true}
              search={(val) => {
                setUserSearch(val); // triggers debouncedUserSearch inside useFetch
                setUserFilters({ limit: 10, page: 1 }); // reset page for new search
              }}
              buttonPlaceholder={"Select Users"}
              dropdownData={removeDuplicateFromArray(
                (users?.data || []).map((user) => ({
                  name: `${user?.firstName || ""} ${
                    user?.lastName || ""
                  }`.trim(),
                  value: user?._id,
                })),
                "value"
              )}
              values={filters?.userIds || []}
              onChange={(val) => {
                setFilters((pre) => ({
                  ...pre,
                  userIds: val,
                  page: 1, // optional: if filters are paginated elsewhere
                }));
              }}
              onScroll={(e) => {
                const { scrollTop, scrollHeight, clientHeight } = e.target;
                if (
                  scrollTop + clientHeight >= scrollHeight - 20 &&
                  users?.metadata?.hasNextPage
                ) {
                  setUserFilters((prev) => ({
                    ...prev,
                    page: users?.metadata?.nextPage, // load next page
                  }));
                }
              }}
              loading={isFetchingUsers}
            />
</div> */}
          {/* <div className="w-72">
            <DatePicker
              // label="Date Range"
              value={dateRange}
              renge={true}
              onChange={setDateRange}
              placeholder="Select date range"
            />
          </div> */}
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-chestnut-rose/10 hover:!border-chestnut-rose/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-chestnut-rose"}
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div> */}
        </div>
      </div>
      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        handleOrdering={(val) => {
          console.log(val);
        }}
        isFetching={isFetching}
        isOrderingDisabled={true}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />
      {/* <ManageFinanceModal
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={donationManageResponse}
      /> */}
      {/* <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      /> */}
    </div>
  );
};

export default Transaction;
